import icon from '../../../assets/icon/alert_modal.svg'

const AlertModal = () => {
  return <img src={icon} alt="icon-download" width="100%" height="100%" />
}

export default AlertModal
